<template>
  <div class="absolute z-10 w-1/4 max-h-1/2 ml-8 top-full transform -translate-y-full -mt-2">
      {{count}}
      <NotificationMessage v-for="notification in notifications" :key="notification.id" :show="true" :notification="notification"/>
  </div>
</template>

<script>
import NotificationMessage from './NotificationMessage'
import { useStore } from 'vuex'
import { computed } from 'vue'
export default {
    components: {
        NotificationMessage,
    },
    setup() {
        const store = useStore()
        return {
            notifications: computed(() => store.state.notify['notifications']),
        }
    }
}
</script>

<style>
.fade-enter-from {
  opacity: 0;
}
.fade-enter-to {
  opacity: 1;
}

.fade-enter-active {
  transition: all 0.3s ease-in-out;
}

.fade-leave-active {
  transition: all 0.3s ease-in-out;
}

.fade-leave-from {
  opacity: 1;
}

.fade-leave-to {
  opacity: 0;
}

</style>